import React from 'react';
export function ServiceFooter() {
  return <section className="bg-charcoal py-16 md:py-24 px-6 fade-section" data-id="element-91">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-12" data-id="element-92">
        {/* Left: VIP Service */}
        <div className="flex flex-col justify-center border-b md:border-b-0 md:border-r border-white/10 pb-12 md:pb-0 md:pr-12" data-id="element-93">
          <span className="font-sans text-sm tracking-ultra-wide text-gold uppercase mb-4" data-id="element-94">
            Reservations & VIP
          </span>
          <a href="tel:2405359729" className="font-serif text-[38px] md:text-[50px] lg:text-[62px] text-gold font-bold hover:text-white transition-colors duration-300" data-id="element-95">
            (240) 535-9729
          </a>
          <span className="font-sans text-sm text-white/40 tracking-widest uppercase mt-4" data-id="element-96">
            Direct Line
          </span>
        </div>

        {/* Right: Hours & Dress Code */}
        <div className="flex flex-col justify-center md:pl-12" data-id="element-97">
          <div className="mb-10" data-id="element-98">
            <span className="font-sans text-sm tracking-ultra-wide text-gold uppercase block mb-4" data-id="element-99">
              Hours
            </span>
            <ul className="space-y-2 font-sans text-lg text-white/70" data-id="element-100">
              <li className="flex justify-between max-w-xs" data-id="element-101">
                <span data-id="element-102">Monday</span>
                <span className="text-white/40" data-id="element-103">Closed</span>
              </li>
              <li className="flex justify-between max-w-xs" data-id="element-104">
                <span data-id="element-105">Tuesday - Thursday</span>
                <span data-id="element-106">6PM - 12AM</span>
              </li>
              <li className="flex justify-between max-w-xs" data-id="element-107">
                <span data-id="element-108">Friday - Saturday</span>
                <span data-id="element-109">6PM - 2AM</span>
              </li>
              <li className="flex justify-between max-w-xs text-gold/80 mt-2" data-id="element-110">
                <span data-id="element-111">Sunday</span>
                <span data-id="element-112">4PM - 11PM</span>
              </li>
            </ul>
          </div>

          <div data-id="element-113">
            <span className="font-sans text-sm tracking-ultra-wide text-gold uppercase block mb-2" data-id="element-114">
              Dress Code
            </span>
            <p className="font-sans text-lg text-white/70" data-id="element-115">
              Sophisticated. No athletic wear, hats, or work boots.
            </p>
          </div>
        </div>
      </div>
    </section>;
}